class PerfTimer {
  constructor(perfTimingService, key) {
    this._start = performance.now();
    this._perfTimingService = perfTimingService;
    this.key = key;
  }

  stop = () => {
    const duration = performance.now() - this._start;
    this._perfTimingService.addTime(this.key, duration);
  }
}

export default PerfTimer;
